import ConfirmAccount from "./ConfirmAccount";
import Footer from "./Footer";
import AccountSelect from "./AccountSelect";

export { ConfirmAccount, Footer, AccountSelect };

export default ConfirmAccount;
